module.exports = __webpack_public_path__ + "media/images/payment-methods-9421ceda.svg";